import SuspendedProductPanel from './suspendedProductPanel.container';

export default SuspendedProductPanel;
